import type { Schema } from '@wix/wix-data-schema-types';
import { SHARED_PLUGIN_ID } from '@wix/wix-data-schema-types';

export const isSharedCollection = (collection?: Schema) =>
  Boolean(collection?.plugins?.[SHARED_PLUGIN_ID]);
